import { useVariant } from '@calendly/feature-check-react'
import { useFormContext, useFormField } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { useMemo } from 'react'
import { useDispatch } from 'react-redux'

import { useGetUserQuery } from 'common'
import { RichTextField } from 'components/core/form'
import { openUserAgreementPopup } from 'features/user_agreements'
import { getLocalizedVariableName } from 'services/get-localized-variable-name'

import { buildDefaultNotification, getDefaultFieldValue, localizeTemplateVariables } from './config'

export const SubjectField = ({
  eventType,
  name,
  disabled,
  label,
  useUpdatedDisabledState = false,
  useUpdatedToolbarActions = false,
  openVariablesDropdownOnLeft = false,
  alignIconOnlyVariablesWithInput = false,
  includeProTip = true,
  etLocked = false
}) => {
  const { values: { noReplyEnabled } } = useFormContext()
  const [{ value: { kind } }] = useFormField(name)
  const { data: currentUser } = useGetUserQuery()
  const aiFeaturesEnabled = ['enabled_multi_buttons'].includes(useVariant('ai_text_editor'))
  const dispatch = useDispatch()
  const showUserAgreement = (onAgree) => dispatch(openUserAgreementPopup({ name: 'ai_beta_terms', onAgree }))

  const defaultNotification = buildDefaultNotification(eventType, kind, { noReplyEnabled })

  const subjectTemplateVariables = useMemo(
    () => localizeTemplateVariables(defaultNotification.variables.subject),
    [defaultNotification.variables.subject]
  )

  // i18n-tasks-use t('publisher.event_types.notifications.invitee_invitation.subject_label')
  // i18n-tasks-use t('publisher.event_types.notifications.invitee_invitation.subject_tip')
  // i18n-tasks-use t('publisher.event_types.notifications.invitee_confirmation.subject_label')
  // i18n-tasks-use t('publisher.event_types.notifications.invitee_confirmation.subject_tip')
  // i18n-tasks-use t('publisher.event_types.notifications.invitee_reminder.subject_label')
  // i18n-tasks-use t('publisher.event_types.notifications.invitee_reminder.subject_tip')
  // i18n-tasks-use t('publisher.event_types.notifications.invitee_email_follow_up.subject_label')
  // i18n-tasks-use t('publisher.event_types.notifications.invitee_email_follow_up.subject_tip')
  // i18n-tasks-use t('publisher.event_types.notifications.invitee_cancellation.subject_label')
  // i18n-tasks-use t('publisher.event_types.notifications.invitee_cancellation.subject_tip')
  return (
    <RichTextField
      id="wysiwyg-subject"
      name={`${name}.subject`}
      label={label || I18n.t(`publisher.event_types.notifications.${kind}.subject_label`)}
      proTip={includeProTip && !disabled && I18n.t(`publisher.event_types.notifications.${kind}.subject_tip`)}
      disabled={disabled || etLocked}
      supportedFormatting={[]}
      plainPaste
      singleLine
      filterAliases
      useUpdatedDisabledState={useUpdatedDisabledState}
      useUpdatedToolbarActions={useUpdatedToolbarActions}
      openVariablesDropdownOnLeft={openVariablesDropdownOnLeft}
      alignIconOnlyVariablesWithInput={alignIconOnlyVariablesWithInput}
      templateVariables={subjectTemplateVariables}
      getLocalizedVariableName={getLocalizedVariableName}
      defaultContent={getDefaultFieldValue(defaultNotification, 'subject')}
      aiFeaturesEnabled={aiFeaturesEnabled}
      editorUsageType={`${name}_subject`}
      eventTypeId={eventType?.id}
      showUserAgreement={showUserAgreement}
      source="et"
      userId={currentUser?.id}
    />
  )
}
